









































import { Vue, Component, Prop, Model } from 'vue-property-decorator';

@Component
export default class RadioInput extends Vue {
  @Model('change', { type: String }) modelValue: '';

  @Prop(String) value: '';
  @Prop(Boolean) invalid: false;
  @Prop(Boolean) disabled: false;
  @Prop(Object) v: () => ({});

  $refs: {
    inputEl: HTMLInputElement;
  }

  /* Destructuring v-model in a getter/setter to have a custom input container */
  get valueBinding () {
    return this.modelValue;
  }

  /* ⬆️ */
  set valueBinding (value) {
    this.$emit('change', value);
  }

  /* Computed data to trigger custom classes in template */
  get checked () {
    return this.modelValue === this.value;
  }

  /*
    Simulates a click in the radio input, so it is accessed with keyboard events
    like a mouse click
  */
  toggle () {
    this.$refs.inputEl.click();
  }
};
